export const WEB_PLATFORM_LABEL = 'Web Scraping';

/** Task-first catalog families whose second slug component names the API. */
export const TASK_FAMILY_LABELS: Readonly<Record<string, string>> = {
  people_search: 'People Search',
  company_search: 'Company Search',
  person_enrichment: 'Person Enrichment',
  company_enrichment: 'Company Enrichment',
  company_identify: 'Company Identify',
  contact_enrichment: 'Contact Enrichment',
  email_finding: 'Email Finding',
  email_verification: 'Email Verification',
  mobile_phone: 'Mobile Phone',
  property_records: 'Property Records',
};
